import { Grid, withStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Label } from '../../default'
import { CardCustomer } from '../../cards'

const PanelCustomer = ({ classes }) => {

  const { t } = useTranslation()

  return (
    <Grid container spacing={3} className={classes.root}>
      <Grid item xs={12}>
        <Label v='h5' bold>{t('panels.customer.title')}</Label>
      </Grid>
      <Grid item xs={12}>
        <CardCustomer />
      </Grid>
    </Grid>
  )
}


const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1
  }
})

export default withStyles(styles)(PanelCustomer)